import React from 'react';
import { connect } from 'react-redux';
import ReactHtmlParser from 'react-html-parser';

class CompareCartValue extends React.PureComponent {

    render() {
        let profileCartListValue = ''

        if (this.props.profileCartList !== undefined && this.props.profileCartList !== null
            && this.props.profileCartList.length > 0) {
            profileCartListValue = this.props.profileCartList.map((profileList) => {
                let priceValue = "";
                if(profileList?.price){
                    if(!isNaN(profileList?.price?.replace("$",""))){
                        priceValue = "$"+Number(profileList?.price?.replace("$","")).toFixed(2)
                    }else{
                        priceValue = profileList?.price;
                    }
                }
                return (
                <span>
                    <span id="SinglesectionIteamName" className="tiny-p-70 medium-p-75 inline-block  ComparePlanTextWrap" style={{width: "55% !important"}}>{ReactHtmlParser(profileList.prodName)}</span>
                    <span id="SinglesectionPrice" className="text-right right medium-p-25">{priceValue}</span>
                </span>)
            }                
            )
        }

        if (this.props.newCartList !== undefined && this.props.newCartList !== null
            && this.props.newCartList.length > 0) {
            profileCartListValue = this.props.newCartList.map((newList, index) => (
                <span>
                    <span id="SinglesectionIteamName" className=" tiny-p-70 medium-p-75 inline-block ComparePlanTextWrap">{ReactHtmlParser(newList.prodName)}</span>
                    <span id="SinglesectionPrice" className="text-right right tiny-p-30 medium-p-25">{newList.price}</span>
                </span>
            ))
        }

        return (
            <React.Fragment>
                <div id="BundlePackgesCSR" className="">
                    <p className="margin-bottom-zero">
                        <li id="profileList" className="" price="$10.00">
                            {profileCartListValue}
                        </li>
                    </p>
                </div>
            </React.Fragment>
        );
    }

}

const mapStateToProps = (state) => {
    return {
        lqState: state.loopQual,
        appState: state.app,
        cart: state.cart,
        router: state.router,
        saveState: state.save,
        profileCart: state.profileCart
    }
}

export default connect(
    mapStateToProps,
)(CompareCartValue);